// ROLLING WINDOW + SEQUENTIAL FILL PROJECTION
// -------------------------------------------------------------------------
// Overwrites the month labels, delivery_end, isXmas flag, and data-sold on
// each dial based on TODAY'S date. Anchor at the top = the most-recently-
// closed month (Full), then N-1 filling/upcoming months.
//
// Rule: exactly ONE Full anchor is visible. As soon as the currently-filling
// month closes (i.e., its lockout date passes), it becomes the new anchor,
// the previous anchor drops off, and the next chronological month enters
// at the bottom. All computed on page load — no scheduled tasks needed.
//
// Christmas: if a rendered month is December, the isXmas flag is set true
// and the JS uses the section's xmasCutoff as the lockout instead of the
// standard deliveryEnd - lead_max_weeks. Update the xmasCutoff annually in
// the section settings (or the acumen.christmas_deadline_date metafield).
//
// To disable and pin rings to acumen.slots + block sold_fallback + block
// labels (i.e., static Sep/Oct/Nov/Dec): remove this IIFE.
// Christmas 2026 (window.AcumenXmas from snippets/acumen-xmas-phase.liquid):
//  - "now" follows the shared clock so ?xmas= previews read correctly
//  - phase b (5 Oct–1 Nov): December ring stays open to the elm cutoff, labelled 45mm Reclaimed Elm;
//    rustic pine shows "from 2nd week of January"
function acumenDmClock(){
  var X = window.AcumenXmas;
  return {
    now: X ? X.now() : Date.now(),
    phase: X ? X.phase : 'a',
    elmCutoff: X ? X.endOf(X.dates.elm) : null,
    elmLabel: X ? X.fmt(X.dates.elm) : '',
    stockCutoff: X && X.dates.stock ? X.endOf(X.dates.stock) : null
  };
}
(function acumenDmRoll(){
  var DAY_MS = 86400000;
  var CK     = acumenDmClock();
  var now    = CK.now;
  var MONTHS_ABBR = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  var MONTHS_FULL = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  function pad2(n){ return n < 10 ? '0' + n : '' + n; }

  document.querySelectorAll('[data-acumen-delivery-months]').forEach(function(root){
    var leadMaxWks = parseInt(root.dataset.leadMaxWeeks, 10) || 10;
    var xmasCutoff = new Date(root.dataset.christmasCutoff).getTime();
    if(CK.phase === 'b' && CK.elmCutoff) xmasCutoff = CK.elmCutoff;
    var dials      = root.querySelectorAll('[data-dm-month]');
    if(!dials.length) return;

    // Find the first "still-fillable" month = smallest month index M whose
    // lockout is in the future (or is the xmas month with cutoff in future).
    var d = new Date(now);
    var y = d.getFullYear();
    var m = d.getMonth(); // 0..11 in local time
    var current = null;
    for(var i = 0; i < 36; i++){
      var yr = y + Math.floor((m + i) / 12);
      var mo = (((m + i) % 12) + 12) % 12;
      var deliveryEnd = new Date(yr, mo + 1, 0, 23, 59, 59).getTime(); // last day of month
      var lockout     = (mo === 11)
        ? xmasCutoff
        : (deliveryEnd - leadMaxWks * 7 * DAY_MS);
      if(lockout > now){ current = { yr: yr, mo: mo }; break; }
    }
    if(!current) return;

    // Anchor = one month BEFORE current (most-recently-closed month).
    var aMo = current.mo - 1;
    var aYr = current.yr;
    if(aMo < 0){ aMo = 11; aYr -= 1; }

    // Walk the anchor + (dials.length - 1) upcoming months, overwriting each
    // dial's data-* attributes and the visible .dm-month text.
    var prevLockout = null;
    dials.forEach(function(dial, offset){
      var mo2 = aMo + offset;
      var yr2 = aYr + Math.floor(mo2 / 12);
      mo2 = (((mo2 % 12) + 12) % 12);
      var lastDay = new Date(yr2, mo2 + 1, 0).getDate();
      var deliveryEndISO = yr2 + '-' + pad2(mo2 + 1) + '-' + pad2(lastDay) + 'T23:59:59';
      var deliveryEndTs  = new Date(yr2, mo2 + 1, 0, 23, 59, 59).getTime();
      var isXmas         = (mo2 === 11);
      var lockout        = isXmas ? xmasCutoff : (deliveryEndTs - leadMaxWks * 7 * DAY_MS);
      var denom          = parseInt(dial.dataset.denominator, 10) || 400;

      // Sequential fill window: [prevLockout, this month's lockout].
      var winStart = prevLockout !== null
        ? prevLockout
        : (lockout - leadMaxWks * 7 * DAY_MS);
      var fillFrac;
      if(now >= lockout)         fillFrac = 1;
      else if(now <= winStart)   fillFrac = 0;
      else                       fillFrac = (now - winStart) / (lockout - winStart);
      var sold = Math.round(fillFrac * denom);

      dial.dataset.monthAbbr    = MONTHS_ABBR[mo2];
      dial.dataset.monthName    = MONTHS_FULL[mo2];
      dial.dataset.deliveryEnd  = deliveryEndISO;
      dial.dataset.christmas    = isXmas ? 'true' : 'false';
      dial.dataset.sold         = String(sold);
      var monthEl = dial.querySelector('.dm-month');
      if(monthEl) monthEl.textContent = MONTHS_ABBR[mo2];

      prevLockout = lockout;
    });
  });
})();

(function(){
  var roots = document.querySelectorAll('[data-acumen-delivery-months]');
  roots.forEach(function(root){
  var DAY = 86400000;
  var CK = acumenDmClock();
  var now = function(){ return CK.now; };
  var elmExt = CK.phase === 'b' && CK.elmCutoff;
  var pineJan = CK.phase !== 'a';
  var leadMinWks = parseInt(root.dataset.leadMinWeeks, 10) || 8;
  var leadMaxWks = parseInt(root.dataset.leadMaxWeeks, 10) || 10;
  var xmas = new Date(root.dataset.christmas).getTime();
  var xmasCutoff = new Date(root.dataset.christmasCutoff).getTime();
  if(elmExt) xmasCutoff = CK.elmCutoff;
  var urgentAtPct = parseInt(root.dataset.urgentAtPct, 10) || 80;
  var displayMode = root.dataset.displayMode || 'filled';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var C = 2 * Math.PI * 86;
  var fmtShort = function(t){ return new Date(t).toLocaleDateString('en-GB',{day:'numeric',month:'short'}); };
  var fmtRange = function(a,b){ return fmtShort(a) + ' – ' + fmtShort(b); };

  root.querySelectorAll('[data-dm-month]').forEach(function(dial){
    var monthAbbr = dial.dataset.monthAbbr || '';
    var monthName = dial.dataset.monthName || monthAbbr;
    var deliveryEnd = new Date(dial.dataset.deliveryEnd).getTime();
    var denom = parseInt(dial.dataset.denominator, 10) || 1;
    var sold = Math.max(0, parseInt(dial.dataset.sold, 10) || 0);
    var isXmas = dial.dataset.christmas === 'true';

    var orderBy = isXmas ? xmasCutoff : (deliveryEnd - leadMaxWks * 7 * DAY);
    var closedByDate = now() > orderBy;
    var pct = Math.min(100, Math.round((sold / denom) * 100));
    var closed = closedByDate || pct >= 100;

    var pctEl = dial.querySelector('[data-dm-pct]');
    var pctSubEl = dial.querySelector('[data-dm-pct-sub]');
    var deliverEl = dial.querySelector('[data-dm-deliver]');
    var ring = dial.querySelector('.dm-fill');

    if(closed){
      dial.classList.add('is-full');
      pctEl.textContent = 'Full';
      pctSubEl.textContent = 'Booked up';
    } else {
      dial.classList.add(pct >= urgentAtPct ? 'is-urgent' : 'is-open');
      if(displayMode === 'remaining'){
        pctEl.textContent = (100 - pct) + '%';
        pctSubEl.textContent = 'Remaining';
      } else {
        pctEl.textContent = pct + '%';
        pctSubEl.textContent = 'Filled';
      }
    }

    var deliverHtml;
    if(closed){
      deliverHtml = '<span class="dm-lab">Delivery</span>Fully booked';
    } else if(isXmas && elmExt){
      deliverHtml = '<span class="dm-lab">Order by ' + fmtShort(orderBy) + '</span><b>45mm Reclaimed Elm</b>';
    } else if(isXmas){
      deliverHtml = '<span class="dm-lab">Order by ' + fmtShort(orderBy) + '</span><b>Home for Christmas</b>';
    } else if(pineJan && new Date(deliveryEnd).getMonth() === 0 && new Date(deliveryEnd).getFullYear() === 2027){
      deliverHtml = '<span class="dm-lab">Rustic pine</span><b>From 2nd week of January</b>';
    } else {
      var etaMin = now() + leadMinWks * 7 * DAY;
      var etaMax = now() + leadMaxWks * 7 * DAY;
      var monthStart = new Date(new Date(deliveryEnd).getFullYear(), new Date(deliveryEnd).getMonth(), 1).getTime();
      var landsHere = etaMax <= deliveryEnd && etaMin >= monthStart;
      if(landsHere){
        deliverHtml = '<span class="dm-lab">Order today, arrives</span><b>' + fmtRange(etaMin, etaMax) + '</b>';
      } else {
        deliverHtml = '<span class="dm-lab">Delivery</span>' + monthName;
      }
    }
    deliverEl.innerHTML = deliverHtml;

    var fillFrac = closed ? 1 : (sold / denom);
    if(fillFrac > 1) fillFrac = 1;
    ring.setAttribute('stroke-dasharray', C);
    ring.setAttribute('stroke-dashoffset', C);
    ring.dataset.target = fillFrac;
  });

  var rings = Array.prototype.slice.call(root.querySelectorAll('.dm-fill'));
  function fill(){
    rings.forEach(function(r, i){
      var t = parseFloat(r.dataset.target || 0);
      if(reduce){ r.style.strokeDashoffset = C * (1 - t); return; }
      r.style.transition = 'stroke-dashoffset 1.2s cubic-bezier(.22,.61,.36,1)';
      r.style.transitionDelay = (i * 0.14) + 's';
      requestAnimationFrame(function(){ r.style.strokeDashoffset = C * (1 - t); });
    });
  }
  if(reduce || !('IntersectionObserver' in window)){ fill(); }
  else {
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ fill(); io.disconnect(); } });
    }, { threshold: 0.35 });
    io.observe(root);
  }

  var dyn = root.querySelector('[data-dm-dynamic]');
  if(dyn){
    if(elmExt){
      dyn.innerHTML = 'Rustic pine tables now deliver from the 2nd week of January. For Christmas, order <b>45mm Reclaimed Elm</b> by <b>' + fmtShort(xmasCutoff) + '</b>, or <b>65mm Reclaimed Elm &amp; Signature</b> by <b>' + fmtShort(CK.stockCutoff) + '</b>.';
    } else if(now() > xmasCutoff && CK.stockCutoff && now() <= CK.stockCutoff){
      dyn.innerHTML = 'Rustic pine tables now deliver from the 2nd week of January. <b>65mm Reclaimed Elm &amp; Signature</b> tables ordered by <b>' + fmtShort(CK.stockCutoff) + '</b> still arrive for Christmas.';
    } else if(now() > xmasCutoff){
      dyn.innerHTML = "This year's Christmas orders have now closed — we'll deliver in the new year.";
    } else {
      var eta = now() + leadMaxWks * 7 * DAY;
      var buffer = Math.floor((xmas - eta) / DAY);
      var spare = buffer > 7 ? ('with ' + buffer + ' days to spare')
                : (buffer >= 0 ? 'just in time' : 'cutting it fine');
      dyn.innerHTML = 'Order today and your table is home by <b>' + fmtShort(eta) + '</b> — ' + spare + ' before Christmas.';
    }
  }
  });
})();
